<template>
  <div class="page">
    <div class="home-page page-container">
      <div class="intro" v-html="intro"></div>
      <div class="entrance flex-ha-vc">
        <div class="form-box flex-v flex-hc-vc" @click="goToPage('Form')">
          <div class="form-image"></div>
          <span>立即预约</span>
        </div>
        <div class="list-box flex-v flex-hc-vc" @click="goToPage('List')">
          <div class="list-image"></div>
          <span>我的预约</span>
        </div>
      </div>
      <div class="tips" v-html="tips"></div>
    </div>
    <div class="loading-container" v-if="loading">
      <a-spin class="loading"/>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import queryString from 'query-string'
import { get } from 'lodash'
import JSB from '@/assets/js/jsbridge'
import './index'

const loginUrl = {
  // h5 公众号渠道下架
  h5: '//mobser.luckyair.net/mp/h5-static/login.html?done=' + decodeURIComponent(window.location.href),
  android: '/login.html?done=' + decodeURIComponent(window.location.href),
  ios: '/login.html?done=' + decodeURIComponent(window.location.href)
}
export default {
  name: 'App',
  data () {
    return {
      loading: false,
      // TODO: cms 配置
      intro: `
      <p>
        为更好的服务祥鹏航空用户，即日起祥鹏航空实名认证用户可在线提交国际机票购票预约申请，祥鹏航空将根据航班可利用座位情况，通知后旅客办理购票手续。
      </p>`,
      tips: `
      <p>温馨提示：</p>
      <p>1.购票预约功能目前支持祥鹏承运的国际航班，我们将根据开通航线适时增加可预约的航班。</p>
      <p>2.预约联系人须为祥鹏航空官网实名认证会员，请您填写注册时预留的有效手机号码。</p>
      <p>3.每个祥鹏航空官网实名认证会员账号同一航班出行日期最多可为一位旅客进行购票预约。</p>
      <p>4.成功提交购票预约申请的旅客，当您预期乘坐的航班有空余座位或航线开通时，您将收到祥鹏航空客服热线95326的短信通知，请您留意查看。</p>
      <p>5.如您的同行人中有儿童或婴儿旅客，在收到祥鹏航空客服短信通知后，请联系祥鹏航空客服热线95326为儿童或婴儿办理购票。</p>
      <p>6.特殊时期，航班座位有限,可能无法满足您的需求，敬请谅解。</p>`,
      userInfo: null
    }
  },
  async created () {
    const params = queryString.parse((location.search), { decode: false })
    const { userId, source, channel } = params
    this.loading = true
    try {
      if ((source === 'mobile' && channel)) {
        if (userId) {
          this.$ls.set('USER_CENTER_TOKEN', userId, 2 * 60 * 60 * 1000)
          await this.fetchUserInfo(userId, channel)
        } else {
          if (channel === 'android' || channel === 'ios') {
            const { token } = await JSB.apis.getAccessToken()

            if (token) {
              this.$ls.set('USER_CENTER_TOKEN', token, 2 * 60 * 60 * 1000)
              await this.fetchUserInfo(token, channel)
            } else {
              await JSB.apis.loginSync()
            }
          } else {
            this.loading = false
            this.$message.error('信息缺失，请重新进入')
          }
        }
      } else {
        this.loading = false
        this.$message.error('信息缺失，请重新进入')
      }
    } catch (error) {
      this.loading = false
      this.$message.error('信息缺失，请重新进入')
    }
  },
  methods: {
    // 获取用户信息
    async fetchUserInfo (userId, channel) {
      try {
        const infoData = await axios({
          method: 'get',
          url: '/psg-community-user/api/user/info',
          headers: { token: userId }
        })

        this.userInfo = get(infoData, 'data.data.user') ? get(infoData, 'data.data.user') : get(infoData, 'user')
        const { userInfo } = this

        if (userInfo) {
          this.$ls.set('USER_CENTER_INFO', userInfo)
          this.loading = false
        } else {
          window.location.href = loginUrl[channel]
        }
      } catch (err) {
        this.$message.error(err.message)
      }
    },
    // 同步会话信息
    // async syncSession (userId, channel) {
    //   try {
    //     const params = {
    //       token: userId
    //     }
    //     const loginData = await request({
    //       method: 'post',
    //       url: '/api/member/syncSession',
    //       data: params
    //     })
    //     if (loginData) {
    //       this.loading = false
    //     } else {
    //       window.location.href = loginUrl[channel]
    //     }
    //   } catch (err) {
    //     this.$message.error(err.message)
    //   }
    // },
    goToPage (pageName) {
      const params = queryString.parse((location.search), { decode: false })
      const { userId, channel } = params
      const { userInfo } = this || this.$ls.get('USER_CENTER_INFO')
      if (!userInfo) {
        this.$message.error('请先登录')
        return false
      }
      const hasAuth = userInfo.userType !== 0 || userInfo.authStatus === 4
      if (!hasAuth) {
        const href = document.location.href
        this.$confirm({
          title: '温馨提示',
          content: '国际航班预约仅对实名认证用户开放，请完成实名认证后再进行预。',
          okText: '去实名认证',
          cancelText: '取消',
          onOk: () => {
            window.sessionStorage.setItem('redirect', href)
            // TODO: 待确定
            window.location.href = `/h5/authenticateMobile.html?channel=${channel}&type=auth&userId=${userId}`
          }
        })
      } else {
        this.$router.push({ path: `/server/intlTicketBooking${pageName}` })
      }
    }
  }
}
</script>
